export const TRACKING_CONSENT_COOKIE = 'wb-tracking-consent';
export const THEME_MODE_COOKIE = 'wb-theme-mode';
